import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatchInfoDTO, MatchPlayerStatsDetailsDTO } from '@solverml/api';

/**
 * Componente "Dumb" (Vista) que muestra el "Box Score":
 * las estadísticas de los jugadores (goles, exclusiones)
 * separadas por equipo (Local/Visitante) en pestañas.
 */
@Component({
  selector: 'app-match-player-stats',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTabsModule,
    MatTableModule,
    MatIconModule,
    RouterLink
  ],
  templateUrl: './match-player-stats.component.html',
  styleUrls: ['./match-player-stats.component.scss']
})
export class MatchPlayerStatsComponent {

  /**
   * Lista de todas las estadísticas de jugadores para este partido.
   */
  @Input({ required: true }) playerStats!: MatchPlayerStatsDetailsDTO[] | null;

  /**
   * Información del partido (necesaria para los IDs y nombres de los equipos).
   */
  @Input({ required: true }) matchInfo!: MatchInfoDTO | null;

  /**
   * Columnas a mostrar en la tabla de estadísticas.
   */
  public displayedColumns: string[] = ['dorsal', 'playerName', 'goals', 'exclusions'];

  /**
   * Filtra la lista de estadísticas solo para el equipo local.
   */
  get homePlayers(): MatchPlayerStatsDetailsDTO[] {
    if (!this.playerStats || !this.matchInfo) {
      return [];
    }
    return this.playerStats.filter(p => p.team_id === this.matchInfo!.home_team_id);
  }

  /**
   * Filtra la lista de estadísticas solo para el equipo visitante.
   */
  get awayPlayers(): MatchPlayerStatsDetailsDTO[] {
    if (!this.playerStats || !this.matchInfo) {
      return [];
    }
    return this.playerStats.filter(p => p.team_id === this.matchInfo!.away_team_id);
  }
}
